// src/oura/merchant/reportWording.ts
//
// Two lines on the client's Reports and Home screens that read wrong (#4031).
// Pure, so the wording and the count can be checked without a screen.

/**
 * The AI check's band as a phrase a client can read. The backend sends the band
 * as the scan's `aiVisibility.verdict`: `High`, `Medium` or `Low`. "AI apps named
 * you in Low" is not a sentence, so the band sits after what it measures. The
 * caller adds its own full stop, or none.
 */
import { isInAppSnapshot, type ClientReportLink } from "@service/aeo/clientReview";

export function aiBandLine(band: string): string {
    return `How often AI apps name you: ${band}`;
}

/**
 * The reports the client can actually open: a row with a file. A report that is
 * "Not uploaded yet" (an engagement document that lives only on our side) stays
 * in the list, greyed, but is not one they have, so it is not counted.
 */
export function openableReports<T extends { url: string | null; kind?: ClientReportLink["kind"]; assessmentId?: string | null }>(reports: T[]): T[] {
    // The Baseline Snapshot has no file but opens here, so it is one they have (#4457).
    return reports.filter((r) => !!r.url || isInAppSnapshot(r));
}
